import {booleanSchema, RecordSchema, recordSchema, stringSchema, tableSchema} from '@lightweightform/storage';

import {convertDatesAtPathsJson2Js, convertDatesAtPathsJs2Json, sharedSchemas} from '../../shared';
import {pt} from 'oss-registo-kotlin-common-js';

const {bankAccountInfoSchema, makeRegistrationSchema, vatIdSchema, fixedEstablishmentsSchema, OssSchemaType} = sharedSchemas;

const {
  IDS_IN_OTHER_MSS_VALIDATOR,
} = pt.at.oss.kotlin.manual.validator.common;


const UNION_DATES_PATHS = [
  ['relevantDates', 'registrationReqDate'],
  ['relevantDates', 'forecastStartDate'],
  ['relevantDates', 'msidDecisionDate'],
  ['supplyCommencement', 'commencementDate'],
];
export function convertDatesUnionJson2Js(unionForm) {
  return convertDatesAtPathsJson2Js(UNION_DATES_PATHS)(unionForm);
}
export function convertDatesUnionJs2Json(unionForm) {
  return convertDatesAtPathsJs2Json(UNION_DATES_PATHS)(unionForm);
}

/**
 * Union form schema.
 */
export const unionFormSchema: RecordSchema = makeRegistrationSchema({
  currVatId: recordSchema({
    issuingCountry: stringSchema(),
    vatIdNum: stringSchema(),
  }, {isClientOnly: true}),

  actsAsVatGroup: booleanSchema({isClientOnly: true}),

  actsAsElectronicInterface: booleanSchema(),

  notEstablishedInEU: booleanSchema(),

  bankAccountInfo: bankAccountInfoSchema(false),

  fixedEstablishments: fixedEstablishmentsSchema(false),

  idsInOtherMSs: tableSchema(vatIdSchema(IDS_IN_OTHER_MSS_VALIDATOR)), // all MSs except MSID

}, OssSchemaType.UNION);
